import { Facebook, Instagram, Youtube } from "lucide-react";

const TikTokIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.6 20.1a6.34 6.34 0 0 0 10.86-4.43V8.42a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.64-.18z" />
  </svg>
);

const XIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.844l-5.36-6.99L4.16 22H.9l8.02-9.17L.75 2h6.99l4.84 6.4L18.244 2Zm-1.2 18h1.87L7.04 4H5.05l12 16Z" />
  </svg>
);

export const SOCIAL_LINKS = [
  { label: "YouTube", href: "https://youtube.com", icon: <Youtube className="h-5 w-5" />, color: "#FF0000" },
  { label: "TikTok", href: "https://tiktok.com", icon: <TikTokIcon className="h-4 w-4" />, color: "#000000" },
  { label: "Instagram", href: "https://instagram.com", icon: <Instagram className="h-5 w-5" />, color: "#E4405F" },
  { label: "Facebook", href: "https://facebook.com", icon: <Facebook className="h-5 w-5" />, color: "#1877F2" },
  { label: "X", href: "https://x.com", icon: <XIcon className="h-4 w-4" />, color: "#000000" },
];

export const FOOTER_SOCIAL_LINKS = [
  { label: "YouTube", href: "https://youtube.com", icon: <Youtube className="h-4 w-4" /> },
  { label: "TikTok", href: "https://tiktok.com", icon: <TikTokIcon className="h-4 w-4" /> },
  { label: "Instagram", href: "https://instagram.com", icon: <Instagram className="h-4 w-4" /> },
  { label: "Facebook", href: "https://facebook.com", icon: <Facebook className="h-4 w-4" /> },
  { label: "X", href: "https://x.com", icon: <XIcon className="h-4 w-4" /> },
];
